import type { Locale } from "@/lib/i18n";
import { pl, type WShopAdditionalSearchOptionsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wShopAdditionalSearchOptionsTranslations: Record<
  Locale,
  WShopAdditionalSearchOptionsTranslations
> = { pl, en, de };

export type { WShopAdditionalSearchOptionsTranslations };
